import "./Home.css";

import Hero from "./Hero";
import About from "./About";
import Subscribe from "./Subscribe";
import HallOfFame from "./HallOfFame";
import FAQ from "./Faq";

const Home = () => {
  return (
    <div className="app__home">
      <Hero />
      <About />
      <Subscribe />
      <HallOfFame />
      <FAQ />
    </div>
  );
};

export default Home;
